import { DateFields } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { serviceTemplate, services } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: services['otp-settings/templates'],

      backendGeneration: 'nest',

      find: {
        defaultFilter: {
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
          search: undefined,
          channelType: undefined
        }
      },
      create: { redirect: true },

      has: {
        search: false,
        clone: false,
        tabs: false
      },

      width: 600,
      titlePath: 'name',
      formClass: ''
    })
  ]
}
